export default "__VITE_ASSET__Bs1WiiR2__"